const { showError, showNotifikasi } = require('../libs/helper')

module.exports = {
  getWilayah: async g => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-wilayah`,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getProvinsi: async g => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-provinsi`,
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getKota: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-kota`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getKecamatan: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-kecamatan`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getKelurahan: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-kelurahan`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getKib: async g => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-kib`,
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getPdUpd: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-pdupd`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getStatus: async (g, params = { list: 'list' }) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API}sensus-pengguna/get-status?platform=web`,
      params,
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getCaraPerolehan: async g => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-cara-pengolehan`,
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getTingkat: async g => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-tingkat`,
    })
      .then(res => res.data)
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getKobar: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API2}sensus-pengguna/ref-get-kobar`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
  getNoReg: async (g, params) => {
    const result = await g.$http({
      url: `${process.env.VUE_APP_SUBFOLDER_API}sensus-pengguna/get-no-reg`,
      params,
    })
      .then(res => {
        try {
          if (res.data.code == 400 || res.data.code == 401 || res.data.code == 403) { showNotifikasi(g, 'danger', 'Error Get Data', res.data.message) }
        } catch (error) {
          console.log(error)
        }

        return res.data
      })
      .catch(err => {
        showError(g, err, 'Error Get Data')
      })
    return result
  },
}
